// Campus photo for /colleges/miami-university-oxford-ohio: CC0 1.0, by EEJCC, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AFront_view_of_Alumni_Hall%2C_Miami_University.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/miami-university-oxford-ohio/; credited under the photo.
const photo = {
    "slug": "miami-university-oxford-ohio",
    "alt": "Alumni Hall, a red brick building with a green dome, seen down a tree-lined walk on the Miami University campus in Oxford, Ohio",
    "src": "/colleges/miami-university-oxford-ohio/campus-1600.webp",
    "srcSmall": "/colleges/miami-university-oxford-ohio/campus-800.webp",
    "srcMid": "/colleges/miami-university-oxford-ohio/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/miami-university-oxford-ohio/og.jpg",
    "title": "Front view of Alumni Hall, Miami University",
    "author": "EEJCC",
    "license": "CC0 1.0",
    "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AFront_view_of_Alumni_Hall%2C_Miami_University.jpg",
    "read": "2026-10-01"
};

export default photo;
